import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route } from 'react-router-dom';
import FileInput from './FileInput';
import Send from './Send';
import Receive from './Receive';

function handleSubmit(event) {
  event.preventDefault();
  // const reader = new FileReader();
  // reader.readAsText(fileInput.current.files[0]);
  // reader.onload = () => console.log(reader.result);
  // reader.onerror = () => console.log(reader.error);
  file = fileInput.current.files[0];
}

function handleStartCamera(onSuccess, onFailure) {
  // html5QrCode.start({ facingMode: "user" }, config, onSuccess, onFailure);
}

function handleStopCamera() {
  // html5QrCode.stop();
}

function handleParsedPacket(packet) {}

const config = { fps: 10 };

let fileInput = React.createRef();
let file = null;

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Route
        path='/input'
        render={(props) => (
          <FileInput handleSubmit={handleSubmit} fileInput={fileInput} />
        )}
      />
      <Route
        path='/send'
        render={(props) => (
          <Send
            file={file}
            handleStartCamera={handleStartCamera}
            handleStopCamera={handleStopCamera}
          />
        )}
      />
      <Route
        path='/receive'
        render={(props) => (
          <Receive
            handleStartCamera={handleStartCamera}
            handleStopCamera={handleStopCamera}
          />
        )}
      />
      <Route path='/' exact component={App} />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
